import styled from 'styled-components';

export const StyledChartCard = styled.div<{ isCompareChart: boolean; scale?: number }>`
  width: 100%;
  max-width: ${({ isCompareChart }) => (isCompareChart ? '345px' : '422px')};
  ${({ scale }) => scale && `zoom: ${scale};`}
`;
